<template>
  <v-card tile flat>
    <v-img
      gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
      class="white--text align-end"
      position="top center"
      :src="'./data/banner/' + currNews['img_url_' + lang]"
    >
      <v-toolbar class="bg-transparent w-100-pct" absolute flat>
        <v-toolbar-title></v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="ChangeDialog('')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-title class="fz-32-px font-weight-black">
        {{ currNews['title_' + lang] }}
      </v-card-title>
    </v-img>
    <v-card-text class="py-26-px d-flex align-center">
      <div class="font-weight-black ft-color-sub w-180-px text-center">
        {{ $t('SORCE_DOWNLOAD') }}
      </div>
      <v-divider class="mx-8" vertical></v-divider>
      <!-- <v-spacer></v-spacer> -->
      <div>
        <template v-for="item in downloadKeys">
          <v-btn
            v-if="
              currNews.download[item] &&
              mapUrl(currNews.download[item], item)
            "
            :key="item"
            class="w-230-px mx-6-px my-4-px bg-sub px-15-px"
            dark
            @click.stop="download(item)"
          >
            {{ $t('SOURCE_TAB_' + item.toUpperCase()) }}
            <v-icon right class="ml-6-px fz-18-px">mdi-download</v-icon>
          </v-btn>
        </template>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
export default {
  name: 'Source',

  inject: ['checkUrl', 'mapUrl'],

  data() {
    return {}
  },

  computed: {
    ...mapState('common', ['lang']),
    ...mapState('auth', ['isLogin', 'loginUser']),
    ...mapState('news', ['currNews', 'downloadKeys'])
  },

  methods: {
    ...mapMutations('common', ['ChangeDialog']),
    ...mapActions('message', ['setSnackbar']),
    download(key) {
      if (this.isLogin) {
        const routeUrl = this.$router.resolve({
          path: '/download',
          query: { fileName: this.currNews.download[key], fileClass: key }
        })

        window.open(routeUrl.href, '_blank', '')
      } else {
        this.ChangeDialog('Login')
        this.setSnackbar({
          show: true,
          text: 'LOGINERROR_1',
          timeout: 1200
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
